// Layout shared by the device panel pages and their loading skeletons, so a
// skeleton occupies exactly the space of what replaces it.

/** The study list's header bar. */
export const LIST_HEADER =
  "flex min-h-12 flex-wrap items-center gap-x-4 gap-y-2 border-b border-border px-4 py-2";

/** The worklist's heading row. */
export const STUDY_HEAD_ROW =
  "border-b border-border font-mono text-[9px] uppercase tracking-[0.14em] text-fg-dim";

/** A worklist heading cell: the first sits at the table's left edge, a
 * right-aligned one at its right edge. */
export const studyHeadCell = (index: number, align?: "right") =>
  align === "right"
    ? "px-4 py-2 text-right font-normal"
    : `${index ? "px-2" : "px-4"} py-2 text-left font-normal`;

/** A worklist cell at the table's edge (first and last columns), and one inside. */
export const STUDY_EDGE_CELL = "px-4 py-2.5 align-baseline";
export const STUDY_CELL = "px-2 py-2.5 align-baseline";

/** A study row in a list: label, findings, count. */
export const LIST_ROW =
  "grid min-h-[38px] grid-cols-[64px_minmax(0,1fr)_auto] items-baseline gap-3.5 border-t border-border px-4 py-2";

/** A step button in the study page's header (Prev / Next): no taller than the
 * header, so showing it never moves the viewer below. */
export const CASE_STEP_BUTTON =
  "h-auto rounded-xs border border-border-strong px-2 py-0.5 text-xs font-normal text-fg-muted hover:text-fg focus-visible:outline focus-visible:outline-1 focus-visible:outline-signal disabled:opacity-50";

/** The study page's header bar. */
export const CASE_HEADER =
  "flex min-h-9 items-center gap-3 border-b border-border px-4 py-1.5 text-xs";
